export default __webpack_public_path__ + "static/media/reviewComment.adf69476.png";